import React, { Component } from "react";
import Slider from "react-slick";
import Divider from "./Divider";
import AddOpinion from "./AddOpinion";
import AddButton from "./WebElements/AddButton";
import server from "./Server";
import { connect } from "react-redux";
import { setActiveMenu } from "../actions";
import { Waypoint } from "react-waypoint";

class Testemonials extends Component {
	state = {
		testemonials: this.props.getTestemonials(),
		timeout: null,
		showModal: null
	};

	fetchTestimonisals = () => {
		fetch(server.testimonials)
			.then((response) => response.json())
			.then((testemonials) => {
				//console.log(testemonials);
				if (testemonials !== this.state.testemonials) {
					this.props.updateTestemonials(testemonials);
					this.setState({ testemonials });
				}
			})
			.catch((err) => {
				const t = setTimeout(() => {
					this.fetchTestimonisals();
					this.setState({
						timeout: null
					});
				}, 2000);
				this.setState({
					timeout: t
				});
			});
	};

	componentDidMount() {
		this.fetchTestimonisals();
	}

	componentWillUnmount() {
		clearTimeout(this.state.timeout);
	}

	slidePrev = () => {
		this.slider.slickPrev();
	};

	slideNext = () => {
		this.slider.slickNext();
	};

	handleClick = (e) => {
		if (
			e.target.classList.contains("close") ||
			e.target.classList.contains("add-btn") ||
			e.target.parentNode.classList.contains("add-btn")
		) {
			this.setState({
				showModal: !this.state.showModal
			});
		}
	};

	render() {
		const { langBase } = this.props;
		let array = null,
			t = this.state.testemonials;
		const options = {
			dots: true,
			infinite: true,
			speed: 500,
			arrows: false,
			slidesToShow: 2,
			slidesToScroll: 1,
			autoplaySpeed: 5000,
			autoplay: true,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 800,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
				// You can unslick at a given breakpoint now by adding:
				// settings: "unslick"
				// instead of a settings object
			]
		};
		if (t && t.length) {
			array = t.map((object, i) => {
				return (
					<div key={i} className="testimonial">
						<div className="content">
							<p className="description">{object.text[0] + object.text.slice(1).toLowerCase()}</p>
							<h3 className="testimonial-title">
								{object.name}
								<small>{object.date.replace(/^(\d{4})-(\d\d)-(\d\d)T.*/gi, "$3-$2-$1")}</small>
							</h3>
						</div>
					</div>
				);
			});
		}
		return (
			<div className="testemonials">
				{this.state.showModal && (
					<div id="myModal" className="modal-custom" style={{ cursor: "default" }}>
						<div
							className="modal-content-custom"
							style={{
								width: "80%",
								minWidth: "304px",
								display: "flex",
								// alignItems: "center",
								justifyContent: "center",
								background: "#ffffff",
								overflow: "hidden",
								maxHeight: "calc(100vh - 10%)"
								// overflowY: "auto",
								// overflowX: "hidden"
							}}>
							<div className="leftModalImage">{/* <p>Greetings!</p> */}</div>
							<div className="leftSideBox" />
							<AddOpinion handleClick={this.handleClick} store={this.props.store} />
							<div className="rightSideBox" />
						</div>
					</div>
				)}
				<Divider />
				<Waypoint bottomOffset={300} onEnter={() => this.props.setActiveMenu(5)} />
				<h1 id="testimonial-block" className="main-subtitle">
					<button onClick={() => this.slidePrev()}>
						<i className="material-icons pointer">chevron_left</i>
					</button>{" "}
					<span className="first">{langBase.testimonials.split(" ")[0]}</span>{" "}
					{langBase.testimonials.split(" ").slice(1).join("")}
					<button onClick={() => this.slideNext()}>
						<i className="material-icons pointer">chevron_right</i>
					</button>
				</h1>
				<Slider ref={(c) => (this.slider = c)} {...options}>
					{array}
				</Slider>
				<div className="add-opinion">
					{/* <button className="add-btn" onClick={this.handleClick}> */}
					<AddButton
						styles={{ borderRadius: "none" }}
						classes={{ fab: "add-btn" }}
						onClick={this.handleClick}
						text={langBase.addOpinion}
					/>
					{/* </button> */}
				</div>
			</div>
		);
	}
}
const mapStateToProps = (state) => ({
	langBase: state.langBase
});

const mapDispatchToProps = {
	setActiveMenu
};

export default connect(mapStateToProps, mapDispatchToProps)(Testemonials);
